<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入场所名进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
  <!--                  <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>
					<!-- <el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加场所
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row style="margin-top: 10px">
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">场所联系人：</div>
								<div>
									<el-input placeholder="请输入场所联系人" size="medium" v-model="searchValue.ktiContacts"></el-input>
								</div>
							</div>
                        </el-col>
						<el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">联系方式：</div>
								<div>
									<el-input placeholder="请输入场所联系人方式" size="medium" v-model="searchValue.ktiContactWay"></el-input>
								</div>
							</div>
						</el-col>
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">场所状态：</div>
								<div>
									<el-radio-group v-model="searchValue.ktiIsEnable">
										<el-radio :label="0">启用</el-radio>
										<el-radio :label="1">停用</el-radio>
									</el-radio-group>
								</div>
							</div>
                        </el-col>
                        <el-col :span="6" >
							<div class="txt_align_right advance_btn_warp">
								<el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
							</div>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->

                <el-table-column
                        prop="ktiName"
                        align="center"
                        label="场所名称"
                        min-width="20%">
                </el-table-column>
                <el-table-column
                        prop="ktiCostNum"
						label="可用预充值数"
                        align="center"
                        min-width="10%">
                </el-table-column>
				<el-table-column
						label="已生成辩证码数"
				        align="center"
				        min-width="10%">
						<template slot-scope="scope">
							<div v-if="parseInt(scope.row.usedCostNum) > 0" @click="showCostCodeList(scope.row)" style="color: blue;text-decoration: underline;cursor: pointer;">
								{{scope.row.usedCostNum}}
							</div>
							<div v-else>{{scope.row.usedCostNum}}</div>
						</template>
				</el-table-column>
                <el-table-column
                        prop="ktiContacts"
                        label="场所联系人"
                        align="center"
                        min-width="10%">
                </el-table-column>
                <el-table-column
                        prop="ktiContactWay"
						label="场所联系方式"
                        align="center"
                        min-width="20%">
                </el-table-column>

                <el-table-column
                        fixed="right"
                        min-width="30%"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
						<el-button @click="getCostCode(scope.row)" style="padding: 3px" size="mini">获取辩证码</el-button>
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" v-if="currentHr.roles[0].roleId == '1001'">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger" v-if="currentHr.roles[0].roleId == '1001'">删除</el-button>
						<el-button @click="goQrcode(scope.row)" style="padding: 3px" size="mini" type="primary">查看二维码</el-button>
						<el-button @click="editCostView(scope.row)" v-if="currentHr.roles[0].roleId == '1001'" style="padding: 3px" size="mini">设置预充值数</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
		<el-dialog :visible.sync="qrcodeDialogVisible" width="50%" @open="showqrCode" ref="qrcodeDialog">
			<div style="display: flex;align-items: center;flex-direction: column;" id="mpQrCode">
				<div class="qrcode" ref="qrCodeUrl" style="width: 200px;"></div>
				<el-button size="medium" type="primary" plain style="width: 200px;margin-top: 20px;" @click="download()">下载二维码</el-button>
			</div>
		</el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="80%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="场所名称:" prop="ktiName">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.ktiName"
									          placeholder="请输入场所名称" maxlength="50" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="场所联系人:" prop="ktiContacts">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.ktiContacts"
									          placeholder="请输入场所联系人" maxlength="20" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
						<el-col :span="7">
						    <el-form-item label="联系方式:" prop="ktiContactWay">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.ktiContactWay"
											  placeholder="请输入联系方式" maxlength="30" show-word-limit></el-input>
								</div>
						    </el-form-item>
						</el-col>
                    </el-row>
                    <el-row>
						<el-col :span="7">
						    <el-form-item label="场所状态:" prop="ktiIsEnable">
						        <el-radio-group v-model="emp.ktiIsEnable">
						            <el-radio :label="0">启用</el-radio>
						            <el-radio :label="1">停用</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
                        
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
		<el-dialog
		        title="设置预充值数"
		        :visible.sync="costDialogVisible"
		        width="80%">
		    <div>
				<el-form :model="emp" :rules="costRules" ref="empForm">
				    <el-row>
				        <el-col :span="7">
				            <el-form-item label="预充值数:" prop="ktiCostNum">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.ktiCostNum"
									          placeholder="请输入场所预充值数" maxlength="50" show-word-limit></el-input>
								</div>
				            </el-form-item>
				        </el-col>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="costDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doEditCost">确 定</el-button>
			  </span>
		</el-dialog>
		<el-dialog
		        title="辩证授权码列表"
		        :visible.sync="costCodeDialogVisible"
		        width="80%">
		    <div>
				<el-radio-group v-model="costCodeUseFlag" @change="handleUseOrNotChange">
				    <el-radio :label="1">已使用</el-radio>
				    <el-radio :label="0">未使用</el-radio>
					<el-radio :label="2">不限</el-radio>
				</el-radio-group>
				<div style="margin-top: 20px;"></div>
				<el-table
				        :data="costCodes"
				        stripe
				        border
	
				        v-loading="costCodeLoading"
				        element-loading-text="正在加载..."
				        element-loading-spinner="el-icon-loading"
				        element-loading-background="rgba(0, 0, 0, 0.8)"
				        style="width: 100%">
				    <el-table-column
				            prop="ktiCostCode"
				            align="center"
				            label="辩证授权码"
				            min-width="25%">
				    </el-table-column>
				    <el-table-column
				            prop="ktiCreateTime"
							label="生成时间"
				            align="center"
				            min-width="25%">
				    </el-table-column>
				    <el-table-column
				            prop="ktiUseTime"
				            label="使用时间"
				            align="center"
				            min-width="25%">
				    </el-table-column>
				    <el-table-column
							label="是否使用"
				            align="center"
				            min-width="25%">
							<template slot-scope="scope">
								<div>{{scope.row.ktiUseTime == null?'未使用':'已使用'}}</div>
							</template>
				    </el-table-column>
				
				</el-table>
				<div style="display: flex;justify-content: flex-end">
				    <el-pagination
				            background
				            @current-change="costCodeCurrentChange"
				            @size-change="costCodeSizeChange"
				            layout="sizes, prev, pager, next, jumper, ->, total, slot"
				            :total="costCodeTotal">
				    </el-pagination>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="costCodeDialogVisible = false">关 闭</el-button>
			  </span>
		</el-dialog>
    </div>
</template>

<script>
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
	import { mapState, mapGetters, mapActions } from 'vuex';
    export default {
        name: "Tenants",
        data() {
            return {
				costCodeUseFlag:2,
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
				costCodes:[],
                loading: false,
				costCodeLoading:false,
				costCodeDialogVisible:false,
				costDialogVisible:false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
                total: 0,
                page: 1,
				size: 10,
				costCodeTotal: 0,
				costCodePage: 1,
				costCodeSize: 10,
                keyword: '',
				tempTenantId:'',
				tempCostCodeTenantId:'',
                emp: {
					ktiName:'',
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:'',
					ktiQrcode:'',
					ktiCostNum:0
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    ktiName: [{required: true, message: '请输入场所名', trigger: 'blur'}],
					ktiContacts: [{required: true, message: '请输入联系人', trigger: 'blur'}],
                    ktiContactWay: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
					ktiIsEnable: [{required: true, message: '请选择场所状态', trigger: 'blur'}]
                },
				costRules:{
					ktiCostNum: [{required: true, message: '请输入场所预充值数', trigger: 'blur'}]
				}
            }
        },
		computed:{
			/* userRoleId(){
				return $store.state.currentHr.roles[0].id;
			} */
			...mapState([
			      'currentHr' // 将 `this.count` 映射为 `store.state.count`
			]),
		},
        mounted() {
			console.log()
            this.initEmps();
            this.initData();
        },
        methods: {
			handleUseOrNotChange(){
				this.initCostCodeList()
			},
			showCostCodeList(data){
				this.costCodeDialogVisible = true
				this.tempCostCodeTenantId = data.ktiId
				this.initCostCodeList(data.ktiId)
			},
			getCostCode(data){
				var that = this
				console.log(data)
				var ktiId = data.ktiId
				this.loading = true;
				let url = '/tenant/basic/getCostCode/' + ktiId ;
				this.getRequest(url).then(resp => {
					this.loading = false;
					if (resp) {
						var code = resp.obj;
						that.$alert(code, '辩证授权码', {
						  confirmButtonText: '确定',
						  callback: action => {
							console.log("sdas")
							that.initEmps();
						  }
						});
					}
				});
			},
			editCostView(data){
				console.log(data)
				this.emp = data;
				this.costDialogVisible = true
			},
			doEditCost(){
				this.$confirm('修改该场所预充值数, 是否继续?', '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				    this.postRequest("/tenant/basic/updateCostNum", this.emp).then(resp => {
				        if (resp) {
				            this.costDialogVisible = false;
				            this.initEmps();
				        }
				    })
				}).catch(() => {
				    
				});

			},
            exportData() {
                window.open('/apis/tenant/basic/export', '_parent');
            },
			goQrcode(data){
				this.$router.push({ path: '/tenantQrcode', query: { ktiId: data.ktiId,ktiName:data.ktiName } });
			},
            emptyEmp() {
                this.emp = {
                    name:'',
                    contacts:'',
                    contactWay:'',
                    isenable:'',
                    qrcodeUrl:'',
					ktiCostNum:0
                }
                this.inputDepName = '';
            },
            showEditEmpView(data) {
				console.log(data)
				data.ktiIsEnable = parseInt(data.ktiIsEnable)
                this.title = '编辑场所信息';
                this.emp = data;
                this.dialogVisible = true;
            },
			getQrcode(data){
				console.log(data.ktiId)
				this.tempTenantId = data.ktiId
				this.qrcodeDialogVisible = true
			},
			showqrCode(){
				vue.nextTick(_ => {
					this.$refs.qrCodeUrl.innerHTML = '';
					var qrcode = new QRCode(this.$refs.qrCodeUrl, {
						text: 'https://wxjkcn.com/weixin/miniprogram/?tenantId='+this.tempTenantId, // 需要转换为二维码的内容
						width: 200,
						height: 200,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
				})
				
			},
			download() {
				//获取canvas标签
				let canvas = document.getElementById('mpQrCode').getElementsByTagName('canvas')
				//创建a标签
				let a = document.createElement('a')
				//获取二维码的url并赋值为a.href
				a.href = canvas[0].toDataURL('img/png')
				//设置下载文件的名字
				a.download = '二维码'
				//点击事件，相当于下载
				a.click()
			},
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.ktiName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$confirm('此操作将永久删除【' + data.ktiName + '】, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.deleteRequest("/tenant/basic/del/" + data.ktiId).then(resp => {
                            if (resp) {
                                this.initEmps();
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
				console.log(this.emp)
                if (this.emp.ktiId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/tenant/basic/update", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/tenant/basic/add", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
			costCodeSizeChange(currentSize){
				this.costCodeSize = currentSize;
				this.initCostCodeList()
			},
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
			costCodeCurrentChange(currentPage){
				this.costCodePage = currentPage;
				this.initCostCodeList()
			},
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加场所';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/tenant/basic/getTenantsList?page=' + this.page + '&size=' + this.size;
                url += "&tenantName=" + this.keyword;
				if (type && type == 'advanced') {
					if (this.searchValue.ktiContacts) {
						url += '&ktiContacts=' + this.searchValue.ktiContacts;
					}
					if (this.searchValue.ktiContactWay) {
						url += '&ktiContactWay=' + this.searchValue.ktiContactWay;
					}
					if (this.searchValue.ktiIsEnable) {
						url += '&ktiIsEnable=' + this.searchValue.ktiIsEnable;
					}
				}
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
			initCostCodeList(){
				this.costCodeLoading = true;
				let url = '/tenant/basic/getTenantCostList?page=' + this.costCodePage 
				+ '&size=' + this.costCodeSize 
				+ '&ktiTenantId=' + this.tempCostCodeTenantId + '&costCodeUseFlag=' + this.costCodeUseFlag;
				this.getRequest(url).then(resp => {
				    this.costCodeLoading = false;
				    if (resp) {
				        this.costCodes = resp.data;
				        this.costCodeTotal = resp.total;
				    }
				});
			}
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
</style>
